// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.dropdown-container {
    position: relative;
    margin-bottom: 10px;
}

.DropDownSelectedButton {
    width: 100%;
    color: #000;
    border: 1px solid #ccc;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.DropDownSelectedButton:hover {
    background-color: #dee0e5;
}

.dropdown-icon {
    width: 12px;
    height: 12px;
}

.dropdown-menu {
    list-style-type: none;
    padding: 0;
    margin: 0;
    position: absolute;
    width: 100%;
    border: 1px solid #ccc;
    background-color: #fff;
    max-height: 150px;
    overflow-y: auto;
    z-index: 1;
}

.dropdown-item {
    margin: 1px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    cursor: pointer;
}

.new-item {
    height: 34px;
    margin: 1px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    cursor: pointer;
}

.new-item:hover, .dropdown-item:hover {
    background-color: #e3e5e8;
}

.edit-button, .delete-button {
    width: 34px;
    height: 34px;
    background-color: rgba(255, 255, 255, 0);
    padding: 0;
    margin-top: 0;
    margin-bottom: 0;
}

.edit-icon, .delete-icon  {
    width: 34px;
    height: 34px;
    align-self: center;
}

.edit-button:hover, .delete-button:hover {
    background-color: #becce1;
}

.icon-container {
    display: flex;
}`, "",{"version":3,"sources":["webpack://./src/GroupDropdownMenu.css"],"names":[],"mappings":";AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,sBAAsB;IACtB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wCAAwC;IACxC,UAAU;IACV,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB","sourcesContent":["\n.dropdown-container {\n    position: relative;\n    margin-bottom: 10px;\n}\n\n.DropDownSelectedButton {\n    width: 100%;\n    color: #000;\n    border: 1px solid #ccc;\n    background-color: #fff;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.DropDownSelectedButton:hover {\n    background-color: #dee0e5;\n}\n\n.dropdown-icon {\n    width: 12px;\n    height: 12px;\n}\n\n.dropdown-menu {\n    list-style-type: none;\n    padding: 0;\n    margin: 0;\n    position: absolute;\n    width: 100%;\n    border: 1px solid #ccc;\n    background-color: #fff;\n    max-height: 150px;\n    overflow-y: auto;\n    z-index: 1;\n}\n\n.dropdown-item {\n    margin: 1px;\n    padding: 0 10px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-bottom: 1px solid #ddd;\n    cursor: pointer;\n}\n\n.new-item {\n    height: 34px;\n    margin: 1px;\n    padding: 0 10px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-bottom: 1px solid #ddd;\n    cursor: pointer;\n}\n\n.new-item:hover, .dropdown-item:hover {\n    background-color: #e3e5e8;\n}\n\n.edit-button, .delete-button {\n    width: 34px;\n    height: 34px;\n    background-color: rgba(255, 255, 255, 0);\n    padding: 0;\n    margin-top: 0;\n    margin-bottom: 0;\n}\n\n.edit-icon, .delete-icon  {\n    width: 34px;\n    height: 34px;\n    align-self: center;\n}\n\n.edit-button:hover, .delete-button:hover {\n    background-color: #becce1;\n}\n\n.icon-container {\n    display: flex;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
